import { MarketplaceWrapper } from "../styles/marketplace";
import Switch from "@mui/material/Switch";
import morc from "../model2/morc1.png";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Web3 from "web3";
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { marketplaceItems } from "../contants";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import detectEthereumProvider from "@metamask/detect-provider";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import { accessSync } from "fs";

const contractAdress = "0x1ED46A7436E5ff19d7dd8fbe7eE825c7f1395459";
const detailContract = "0x709bA3813BA8e40b3650c7935c91B41a5C4D31DE";
const detailAbi = [
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "address", name: "pHeroOwnerAddress", type: "address" },
    ],
    name: "FRIEND_Add_Hero_to_Game",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pToAddress", type: "address" },
      { internalType: "uint256", name: "pAmount", type: "uint256" },
    ],
    name: "FRIEND_Pay_Reward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pPlayerAddress", type: "address" },
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint16", name: "pNewStatus", type: "uint16" },
      {
        internalType: "uint256",
        name: "pActivityCompletionTime",
        type: "uint256",
      },
      { internalType: "uint256", name: "pActivityID", type: "uint256" },
      { internalType: "uint256", name: "pSiegeSide", type: "uint256" },
      {
        internalType: "bool",
        name: "pCalledForLeftoverProcessing",
        type: "bool",
      },
    ],
    name: "FRIEND_Update_Hero_Status",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "pPlayerAddress", type: "address" },
          {
            internalType: "address",
            name: "pNFTContractAddress",
            type: "address",
          },
          { internalType: "uint256", name: "pHeroID", type: "uint256" },
          { internalType: "uint16", name: "pNewStatus", type: "uint16" },
          {
            internalType: "uint256",
            name: "pActivityCompletionTime",
            type: "uint256",
          },
          { internalType: "uint256", name: "pActivityID", type: "uint256" },
          { internalType: "uint256", name: "pSiegeSide", type: "uint256" },
          {
            internalType: "bool",
            name: "pCalledForLeftoverProcessing",
            type: "bool",
          },
        ],
        internalType: "structIGame_Contract.st_Update_Hero_Status",
        name: "pParams",
        type: "tuple",
      },
    ],
    name: "FRIEND_Update_Hero_Status2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pPlayerAddress", type: "address" },
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint16", name: "pAP_Increment_Amount", type: "uint16" },
      { internalType: "uint16", name: "pDP_Increment_Amount", type: "uint16" },
      { internalType: "uint16", name: "pEL_Increment_Amount", type: "uint16" },
      { internalType: "uint16", name: "pNewStatus", type: "uint16" },
    ],
    name: "FRIEND_Upgrade_Hero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "pPlayerAddress", type: "address" },
          {
            internalType: "address",
            name: "pNFTContractAddress",
            type: "address",
          },
          { internalType: "uint256", name: "pHeroID", type: "uint256" },
          {
            internalType: "uint16",
            name: "pAP_Increment_Amount",
            type: "uint16",
          },
          {
            internalType: "uint16",
            name: "pDP_Increment_Amount",
            type: "uint16",
          },
          {
            internalType: "uint16",
            name: "pEL_Increment_Amount",
            type: "uint16",
          },
          { internalType: "uint16", name: "pNewStatus", type: "uint16" },
        ],
        internalType: "structIGame_Contract.st_Upgrade_Hero",
        name: "pParams",
        type: "tuple",
      },
    ],
    name: "FRIEND_Upgrade_Hero2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "address", name: "pHeroOwnerAddress", type: "address" },
    ],
    name: "LIB_Add_Hero_to_Game",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint256", name: "pGemstone_TokenID", type: "uint256" },
    ],
    name: "LIB_Assign_Gemstone_to_Hero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "pGemstone_TokenID", type: "uint256" },
    ],
    name: "LIB_Claim_Floating_Gemstone",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
    ],
    name: "LIB_Claim_Locked_Tokens_for_Sold_Hero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint256", name: "pGemstone_TokenID", type: "uint256" },
    ],
    name: "LIB_Remove_Gemstone_from_Hero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint16", name: "pNew_Tier", type: "uint16" },
    ],
    name: "LIB_Set_Hero_Tier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pContractAddress", type: "address" },
    ],
    name: "OWNER_ONLY_Add_Allowed_Interacting_Contract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pContractAddress", type: "address" },
    ],
    name: "OWNER_ONLY_Remove_Allowed_Interacting_Contract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "pHeroID", type: "uint256" }],
    name: "OWNER_ONLY_Reset_Hero_Status",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "pHCBank_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pTavern_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pGame_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pSiege_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pHC_Fortunes_of_Ventuna_NFT_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pHeC_Token_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pMayinHara_NFT_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pRegular_Hero_NFT_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pExploration_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "pTraining_Contract_Address",
        type: "address",
      },
    ],
    name: "OWNER_ONLY_Set_Contract_Addresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "pIsPaused", type: "bool" }],
    name: "OWNER_ONLY_Set_Pause_State",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "pTier2LockAmount", type: "uint256" },
      { internalType: "uint256", name: "pTier3LockAmount", type: "uint256" },
      { internalType: "uint256", name: "pTier4LockAmount", type: "uint256" },
      { internalType: "uint256", name: "pTier5LockAmount", type: "uint256" },
    ],
    name: "OWNER_ONLY_Set_TierLockAmounts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pTier1RewardMultipleri",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pTier2RewardMultipleri",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pTier3RewardMultipleri",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pTier4RewardMultipleri",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pTier5RewardMultipleri",
        type: "uint256",
      },
    ],
    name: "OWNER_ONLY_Set_TierRewardMultipliers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pToAddress", type: "address" },
      { internalType: "uint256", name: "pAmount", type: "uint256" },
    ],
    name: "OWNER_ONLY_Transfer_Tokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint256", name: "pGemstone_TokenID", type: "uint256" },
    ],
    name: "PUBLIC_Assign_Gemstone_to_Hero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
    ],
    name: "PUBLIC_Claim_Locked_Tokens_for_Sold_Hero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint16", name: "pNew_Tier", type: "uint16" },
    ],
    name: "PUBLIC_Set_Hero_Tier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      { internalType: "uint256", name: "pGemstone_TokenID", type: "uint256" },
    ],
    name: "PUBLIC_Claim_Floating_Gemstone",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint256", name: "pGemstone_TokenID", type: "uint256" },
    ],
    name: "PUBLIC_Remove_Gemstone_from_Hero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "Contract_Addresses",
    outputs: [
      {
        internalType: "address",
        name: "HCBank_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "Game_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "Tavern_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "Siege_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "HC_Fortunes_of_Ventuna_NFT_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "HeC_Token_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "MayinHara_NFT_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "Regular_Hero_NFT_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "Exploration_Contract_Address",
        type: "address",
      },
      {
        internalType: "address",
        name: "Training_Contract_Address",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FOV_NFT_TYPES_GEMSTONE",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pPlayerAddress", type: "address" },
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint256", name: "pRewardAmount", type: "uint256" },
    ],
    name: "FRIEND_VIEW_Apply_Tier_Multiplier_to_Reward",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "pHeroID", type: "uint256" }],
    name: "FRIEND_VIEW_Get_Hero_ActivityID",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "pHeroID", type: "uint256" }],
    name: "FRIEND_VIEW_Get_Hero_Current_Activity_Contract_Address",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pPlayerAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
    ],
    name: "FRIEND_VIEW_Get_Hero_Stats",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "HeroID", type: "uint256" },
          { internalType: "uint16", name: "Tier", type: "uint16" },
          { internalType: "address", name: "OwnerAddress", type: "address" },
          { internalType: "bool", name: "IsMayinHara", type: "bool" },
          { internalType: "uint256", name: "AttackPoints", type: "uint256" },
          { internalType: "uint256", name: "DefencePoints", type: "uint256" },
          { internalType: "uint256", name: "ExplorerLevel", type: "uint256" },
          { internalType: "uint16", name: "StatusID", type: "uint16" },
          { internalType: "uint256", name: "SiegeSide", type: "uint256" },
          {
            internalType: "uint256",
            name: "ActivityCompletionTime",
            type: "uint256",
          },
          { internalType: "uint256", name: "ActivityID", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_AP", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_DP", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_EL", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_MEGA", type: "uint256" },
        ],
        internalType: "structIGame_Contract.stHero_Stats_for_Returning",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GEMSTONE_TYPE_AP",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GEMSTONE_TYPE_DP",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GEMSTONE_TYPE_EL",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GEMSTONE_TYPE_MEGA",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "pTier", type: "uint256" }],
    name: "LIB_PURE_Get_Required_HeC_Lock_Amount_for_Tier",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pPlayerAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "bool", name: "pIsMayinHara", type: "bool" },
    ],
    name: "LIB_VIEW_Get_Current_Hero_Tier",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "address", name: "pPlayerAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint256", name: "pNew_Tier", type: "uint256" },
    ],
    name: "LIB_VIEW_Get_Tier_Changing_Info",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "is_valid", type: "bool" },
          {
            internalType: "uint256",
            name: "currently_locked_amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "required_lock_amount",
            type: "uint256",
          },
        ],
        internalType: "structGame_Contract.stTierChangingInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pPlayerAddress", type: "address" },
      {
        components: [
          { internalType: "uint256", name: "HeroID", type: "uint256" },
          {
            internalType: "address",
            name: "NFTContractAddress",
            type: "address",
          },
          { internalType: "address", name: "OwnerAddress", type: "address" },
          { internalType: "uint16", name: "Internal_Tier", type: "uint16" },
          { internalType: "bool", name: "IsMayinHara", type: "bool" },
          { internalType: "uint16", name: "AttackPoint", type: "uint16" },
          { internalType: "uint16", name: "DefencePoint", type: "uint16" },
          { internalType: "uint16", name: "ExplorerLevel", type: "uint16" },
          { internalType: "uint16", name: "Status", type: "uint16" },
          { internalType: "uint256", name: "GemstoneID_AP", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_DP", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_EL", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_MEGA", type: "uint256" },
        ],
        internalType: "structGame_Contract.stHeroData_Main",
        name: "pHero_Data_Main",
        type: "tuple",
      },
    ],
    name: "LIB_VIEW_Get_Validated_Tier",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "address", name: "pPlayerAddress", type: "address" },
      { internalType: "bool", name: "pWalletCheckEnabled", type: "bool" },
      { internalType: "bool", name: "pHCBankCheckEnabled", type: "bool" },
      { internalType: "bool", name: "pTavernCheckEnabled", type: "bool" },
    ],
    name: "LIB_VIEW_Validate_Hero_Owner",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAYINHARA_DEFAULT_TIER",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ONLY_Get_TierRewardMultipliers",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "TIER_1_REWARD_MULTIPLIER",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "TIER_2_REWARD_MULTIPLIER",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "TIER_3_REWARD_MULTIPLIER",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "TIER_4_REWARD_MULTIPLIER",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "TIER_5_REWARD_MULTIPLIER",
            type: "uint256",
          },
        ],
        internalType: "structGame_Contract.stParam_TierRewardMultipliers",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ONLY_VIEW_Get_TierLockAmounts",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "TIER_2_LOCK_HEC_AMOUNT",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "TIER_3_LOCK_HEC_AMOUNT",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "TIER_4_LOCK_HEC_AMOUNT",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "TIER_5_LOCK_HEC_AMOUNT",
            type: "uint256",
          },
        ],
        internalType: "structGame_Contract.stParam_TierLockAmounts",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "pHeroID", type: "uint256" }],
    name: "VIEW_Does_Hero_Exists_in_Game",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VIEW_Get_Hero_Count",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "pHeroID", type: "uint256" }],
    name: "VIEW_Get_Hero_Current_Status",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
    ],
    name: "VIEW_Get_Hero_Initial_AttackPoints",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
    ],
    name: "VIEW_Get_Hero_Initial_DefencePoints",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
    ],
    name: "VIEW_Get_Hero_Initial_Tier",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pTokenID", type: "uint256" },
    ],
    name: "VIEW_Get_Hero_Levels",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "TokenID", type: "uint256" },
          { internalType: "uint256", name: "AttackPoints", type: "uint256" },
          { internalType: "uint256", name: "DefencePoints", type: "uint256" },
          { internalType: "uint256", name: "ExplorerLevel", type: "uint256" },
        ],
        internalType: "structIGame_Contract.stHero_Levels",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "ix", type: "uint256" }],
    name: "VIEW_Get_Hero_Levels_by_Index",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "TokenID", type: "uint256" },
          { internalType: "uint256", name: "AttackPoints", type: "uint256" },
          { internalType: "uint256", name: "DefencePoints", type: "uint256" },
          { internalType: "uint256", name: "ExplorerLevel", type: "uint256" },
        ],
        internalType: "structIGame_Contract.stHero_Levels",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "pHeroID", type: "uint256" }],
    name: "VIEW_Get_Hero_Stats",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "HeroID", type: "uint256" },
          { internalType: "uint16", name: "Tier", type: "uint16" },
          { internalType: "address", name: "OwnerAddress", type: "address" },
          { internalType: "bool", name: "IsMayinHara", type: "bool" },
          { internalType: "uint256", name: "AttackPoints", type: "uint256" },
          { internalType: "uint256", name: "DefencePoints", type: "uint256" },
          { internalType: "uint256", name: "ExplorerLevel", type: "uint256" },
          { internalType: "uint16", name: "StatusID", type: "uint16" },
          { internalType: "uint256", name: "SiegeSide", type: "uint256" },
          {
            internalType: "uint256",
            name: "ActivityCompletionTime",
            type: "uint256",
          },
          { internalType: "uint256", name: "ActivityID", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_AP", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_DP", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_EL", type: "uint256" },
          { internalType: "uint256", name: "GemstoneID_MEGA", type: "uint256" },
        ],
        internalType: "structIGame_Contract.stHero_Stats_for_Returning",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "pGemstoneID", type: "uint256" }],
    name: "VIEW_Get_HeroID_of_a_Gemstone",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VIEW_Get_Pause_State",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pNFTContractAddress", type: "address" },
      { internalType: "uint256", name: "pHeroID", type: "uint256" },
      { internalType: "uint256", name: "pNew_Tier", type: "uint256" },
    ],
    name: "VIEW_Get_Tier_Changing_Info",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "is_valid", type: "bool" },
          {
            internalType: "uint256",
            name: "currently_locked_amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "required_lock_amount",
            type: "uint256",
          },
        ],
        internalType: "structGame_Contract.stTierChangingInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const abi = [
  {
    inputs: [
      { internalType: "address", name: "_bidToken", type: "address" },
      { internalType: "uint256", name: "_feeRatio", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nftContract",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "AuctionCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      { indexed: false, internalType: "uint256", name: "bid", type: "uint256" },
      {
        indexed: false,
        internalType: "address",
        name: "nftContract",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "NewBid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "withdrawer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftContract",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "WithdrawFunds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "withdrawer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftContract",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "WithdrawToken",
    type: "event",
  },
  {
    inputs: [
      { internalType: "address", name: "_newNFTAddress", type: "address" },
    ],
    name: "addNewContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_auctionId", type: "uint256" }],
    name: "allBids",
    outputs: [
      { internalType: "address[]", name: "", type: "address[]" },
      { internalType: "uint256[]", name: "", type: "uint256[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "auctions",
    outputs: [
      { internalType: "address", name: "creator", type: "address" },
      { internalType: "uint256", name: "startPrice", type: "uint256" },
      { internalType: "uint256", name: "maxBid", type: "uint256" },
      { internalType: "address", name: "maxBidder", type: "address" },
      { internalType: "uint256", name: "directBuyPrice", type: "uint256" },
      { internalType: "uint256", name: "minIncrement", type: "uint256" },
      { internalType: "bool", name: "isDirectBuy", type: "bool" },
      { internalType: "bool", name: "isCancelled", type: "bool" },
      { internalType: "uint256", name: "endTime", type: "uint256" },
      { internalType: "address", name: "nftAddress", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "uint256", name: "feeRatio", type: "uint256" },
      { internalType: "uint256", name: "auctionId", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_nftContract", type: "address" },
      { internalType: "uint256", name: "_tokenId", type: "uint256" },
    ],
    name: "cancelAuction",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_endTime", type: "uint256" },
      { internalType: "uint256", name: "_minIncrement", type: "uint256" },
      { internalType: "uint256", name: "_directBuyPrice", type: "uint256" },
      { internalType: "uint256", name: "_startPrice", type: "uint256" },
      { internalType: "address", name: "_nftAddress", type: "address" },
      { internalType: "uint256", name: "_tokenId", type: "uint256" },
    ],
    name: "createAuction",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_nftContract", type: "address" },
      { internalType: "uint256", name: "_tokenId", type: "uint256" },
    ],
    name: "exchangeAssets",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_lastNumber", type: "uint256" }],
    name: "getAuctionInfo",
    outputs: [
      { internalType: "uint256[]", name: "directBuy", type: "uint256[]" },
      { internalType: "address[]", name: "owner", type: "address[]" },
      { internalType: "uint256[]", name: "highestBid", type: "uint256[]" },
      { internalType: "address[]", name: "highestBidder", type: "address[]" },
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      { internalType: "uint256[]", name: "endTime", type: "uint256[]" },
      { internalType: "uint256[]", name: "startPrice", type: "uint256[]" },
      { internalType: "uint256[]", name: "auctionStates", type: "uint256[]" },
      {
        internalType: "address[]",
        name: "auctionNFTAddress",
        type: "address[]",
      },
      { internalType: "uint256[]", name: "auctionIds", type: "uint256[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAuctionNumber",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_auctionId", type: "uint256" }],
    name: "getAuctionState",
    outputs: [
      {
        internalType: "enum AuctionManagerCustomToken.AuctionState",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBidToken",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_lastNumber", type: "uint256" }],
    name: "getClaimableBids",
    outputs: [
      { internalType: "uint256[]", name: "highestBid", type: "uint256[]" },
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      {
        internalType: "address[]",
        name: "auctionNFTAddress",
        type: "address[]",
      },
      { internalType: "uint256[]", name: "auctionIds", type: "uint256[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_lastNumber", type: "uint256" }],
    name: "getClaimableNFTs",
    outputs: [
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      {
        internalType: "address[]",
        name: "auctionNFTAddress",
        type: "address[]",
      },
      { internalType: "uint256[]", name: "auctionIds", type: "uint256[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getFeeRatio",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNFTList",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_lastNumber", type: "uint256" }],
    name: "getUserAuctions",
    outputs: [
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      {
        internalType: "address[]",
        name: "auctionNFTAddress",
        type: "address[]",
      },
      { internalType: "uint256[]", name: "auctionIds", type: "uint256[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_nftContract", type: "address" },
    ],
    name: "getUserTokenIds",
    outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "isClaimed",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "nftContractAuctions",
    outputs: [
      { internalType: "address", name: "creator", type: "address" },
      { internalType: "uint256", name: "startPrice", type: "uint256" },
      { internalType: "uint256", name: "maxBid", type: "uint256" },
      { internalType: "address", name: "maxBidder", type: "address" },
      { internalType: "uint256", name: "directBuyPrice", type: "uint256" },
      { internalType: "uint256", name: "minIncrement", type: "uint256" },
      { internalType: "bool", name: "isDirectBuy", type: "bool" },
      { internalType: "bool", name: "isCancelled", type: "bool" },
      { internalType: "uint256", name: "endTime", type: "uint256" },
      { internalType: "address", name: "nftAddress", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "uint256", name: "feeRatio", type: "uint256" },
      { internalType: "uint256", name: "auctionId", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "nftContracts",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "nftContractsList",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_nftContract", type: "address" },
      { internalType: "uint256", name: "_tokenId", type: "uint256" },
      { internalType: "uint256", name: "_bidValue", type: "uint256" },
    ],
    name: "placeBid",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "newFeeRatio", type: "uint256" }],
    name: "setFeeRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const HoV_RACE_GENDER_HUMAN_MALE = 1;
const HoV_RACE_GENDER_HUMAN_FEMALE = 2;
const HoV_RACE_GENDER_ORC_MALE = 3;
const HoV_RACE_GENDER_ORC_FEMALE = 4;
const HoV_RACE_GENDER_ELF_MALE = 5;
const HoV_RACE_GENDER_ELF_FEMALE = 6;
const HoV_RACE_GENDER_DWARF_MALE = 7;
const HoV_RACE_GENDER_DWARF_FEMALE = 8;

const HoV_CLASS_WARRIOR = 1;
const HoV_CLASS_RANGER = 2;
const HoV_CLASS_MAGE = 3;
const HoV_CLASS_ASSASSIN = 4;
const HoV_CLASS_TANK = 5;
const HoV_CLASS_CLERIC = 6;

const Marketplace = () => {
  const navigate = useNavigate();
  const [forsale, setForsale] = useState(true);
  const [open, setOpen] = useState({
    nftCollection: false,
    nftType: false,
    behaviors: false,
    slots: false,
    catalyst: false,
    gems: false,
  });
  const [gemValue, setGemValue] = useState(0);
  const [sortedAuctions, setSortedAuctions] = useState([]);
  const [allMarketNft, setAllMarketNft] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([
    "Archer",
    "Cleric",
    "Mage",
    "Tank",
    "Warrior",
  ]);
  const [selectedCollections, setSelectedCollections] = useState([
    "MayinHara",
    "Fortunes of Ventuna",
    "Weapon",
    "Heroes of Ventuna"
  ]);
  const [selectedArmourMaterials, setSelectedArmourMaterials] = useState([
    "Ithara",
    "Jeela",
    "Nilchee",
    "Talam",
    "Tamburian",
  ]);
  const [selectedHeads, setSelectedHeads] = useState([
    "Galleer I",
    "Galleer II",
    "Galleer III",
  ]);
  const [selectedTorsos, setSelectedTorsos] = useState([
    "Thrax I",
    "Thrax II",
    "Thrax III",
  ]);
  const [selectedArms, setSelectedArms] = useState([
    "Kastus I",
    "Kastus II",
    "Kastus III",
  ]);
  const [selectedShoulders, setSelectedShoulders] = useState([
    "Skappa I",
    "Skappa II",
    "Skappa III",
  ]);
  const [selectedSkirts, setSelectedSkirts] = useState(["Lakka I", "Lakka II"]);
  const [selectedWings, setSelectedWings] = useState([
    "Hallis I",
    "Hallis II",
    "Hallis III",
    "Hallis IV",
  ]);
  const [selectedAPs, setSelectedAPs] = useState([
    "0",
    "0.5",
    "0.75",
    "1",
    "1.25",
    "1.5",
  ]);
  const [selectedDPs, setSelectedDPs] = useState([
    "0",
    "0.5",
    "0.75",
    "1",
    "1.25",
    "1.5",
  ]);
  const [selectedSCs, setSelectedSCs] = useState([
    "0",
    "0.5",
    "0.75",
    "1",
    "1.25",
    "1.5",
  ]);
  const [selectedUSs, setSelectedUSs] = useState([
    "0",
    "0.5",
    "0.75",
    "1",
    "1.25",
    "1.5",
  ]);
  const [selectedHBs, setSelectedHBs] = useState([
    "0",
    "0.5",
    "0.75",
    "1",
    "1.25",
    "1.5",
  ]);
  const [selectedTypes, setSelectedTypes] = useState([
    "Gemstone",
    "Training Ticket",
  ]);
  const [selectedGenderTypes, setSelectedGenderTypes] = useState([
    "Male",
    "Female",
  ]);
  const [selectedRaceypes, setSelectedRaceypes] = useState([
    "Human",
    "Orc",
    "Elf",
    "Dwarf"
  ]);
  const [selectedClassHovType, setSelectedClassHovType] = useState([
    "Warrior",
    "Ranger",
    "Mage",
    "Assassin",
    "Tank",
    "Cleric"
  ]);
  const [selectedTrainingTypes, setSelectedTrainingTypes] = useState([
    "Attacking",
    "Defending",
  ]);
  const [selectedGemstoneType, setSelectedGemstoneType] = useState([
    "Attacking",
    "Defending",
    "Explorer Level",
    "MEGA",
  ]);
  const [selectedBoostAmount, setSelectedBoostAmount] = useState([
    "1",
    "2",
    "3",
  ]);
  const [selectedUpgradeAmount, setSelectedUpgradeAmount] = useState([
    "1",
    "2",
    "3",
  ]);
  const [selectedTrainingHours, setSelectedTrainingHours] = useState([
    "0",
    "72",
    "120",
    "168",
  ]);

  const [selectedGenerations, setSelectedGenerations] = useState([
    "The Beacons of Light",
    "The Bringers of Day",
    "The First Hope",
    "The Judgement Bearers",
    "The Last Guard",
  ]);
  const [pleaseWait, setPleaseWait] = useState(true);
  const [isFilter, setIsFilter] = useState(true);
  const [textInput, setTextInput] = useState("");
  const [aplevelval, setAplevelval] = useState("0");
  const [dplevelval, setDplevelval] = useState("0");
  const [ellevelval, setEllevelval] = useState("0");
  const { ethereum } = window;
  const { publicKey, walletType } = useSelector((state) => state.wallet);

  const handleGemValue = (e) => {
    setGemValue(e.value);
  };

  const [checked, setChecked] = useState([0]);

  const [age, setAge] = useState("");
  const [selected, setSelected] = useState([]);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const parseFoVTokenID = (token_id) => {
    if (token_id.length != 18) return "";

    try {
      var token_type = token_id.substr(0, 1);
      var stat_type = parseInt(token_id.substr(1, 1));
      var upgrade_amount = parseInt(token_id.substr(2, 1));

      var name = "";
      var short_name = "";

      if (token_type == "1") {
        if (upgrade_amount < 1 || upgrade_amount > 5) return "";

        if (stat_type != 1 && stat_type != 2) return "";

        var duration_hours = parseInt(token_id.substr(3, 7)) / 60;

        if (stat_type == 1) short_name = "AP";
        else if (stat_type == 2) short_name = "DP";

        name =
          "Training Ticket " +
          short_name +
          "+" +
          upgrade_amount +
          " (" +
          duration_hours +
          " hours)";
      } else if (token_type == "2") {
        if (upgrade_amount < 1 || upgrade_amount > 5) return "";

        if (stat_type < 1 || stat_type > 4) return "";

        if (stat_type == 1) short_name = "AP";
        else if (stat_type == 2) short_name = "DP";
        else if (stat_type == 3) short_name = "EL";
        else if (stat_type == 4) short_name = "MEGA";

        name = "Gemstone " + short_name + "+" + upgrade_amount;
      } else if (token_type == "3") {
        var HoV_RACE_gender_id = parseInt(token_id.substr(1, 1));
        var HoV_CLASS_id = parseInt(token_id.substr(2, 1));

        if (
          HoV_RACE_gender_id < HoV_RACE_GENDER_HUMAN_MALE ||
          HoV_RACE_gender_id > HoV_RACE_GENDER_DWARF_FEMALE
        )
          return "";

        if (HoV_CLASS_id < HoV_CLASS_WARRIOR || HoV_CLASS_id > HoV_CLASS_CLERIC)
          return "";

        return (
          Get_Gender_Text(HoV_RACE_gender_id) +
          " " +
          Get_HoV_RACE_Text(HoV_RACE_gender_id) +
          " - " +
          Get_HoV_CLASS_Text(HoV_CLASS_id)
        );
      }

      return name;
    } catch (ex) {
      return "";
    }
  };

  const getFovAttributes = (token_id) => {
    if (token_id.length != 18) return "";

    try {
      var token_type = token_id.substr(0, 1);
      var stat_type = parseInt(token_id.substr(1, 1));
      var upgrade_amount = parseInt(token_id.substr(2, 1));

      var name = [];
      var short_name = "";

      if (token_type == "1") {
        if (upgrade_amount < 1 || upgrade_amount > 5) return "";

        if (stat_type != 1 && stat_type != 2) return "";

        var duration_hours = parseInt(token_id.substr(3, 7)) / 60;

        if (stat_type == 1) short_name = "Attacking";
        else if (stat_type == 2) short_name = "Defending";

        //name = "Training Ticket " + short_name + "+" + upgrade_amount + " (" + duration_hours + " hours)";
        name = ["Training Ticket", short_name, upgrade_amount, duration_hours];
      } else if (token_type == "2") {
        if (upgrade_amount < 1 || upgrade_amount > 5) return "";

        if (stat_type < 1 || stat_type > 4) return "";

        if (stat_type == 1) short_name = "Attacking";
        else if (stat_type == 2) short_name = "Defending";
        else if (stat_type == 3) short_name = "Explorer Level";
        else if (stat_type == 4) short_name = "MEGA";

        //name = "Gemstone " + short_name + "+" + upgrade_amount;
        name = ["Gemstone", short_name, upgrade_amount, "0"];
      } else if (token_type == "3") {
        var HoV_RACE_gender_id = parseInt(token_id.substr(1, 1));
        var HoV_CLASS_id = parseInt(token_id.substr(2, 1));

        if (
          HoV_RACE_gender_id < HoV_RACE_GENDER_HUMAN_MALE ||
          HoV_RACE_gender_id > HoV_RACE_GENDER_DWARF_FEMALE
        )
          return "";

        if (HoV_CLASS_id < HoV_CLASS_WARRIOR || HoV_CLASS_id > HoV_CLASS_CLERIC)
          return "";

        name = [
          "Heroes of Ventuna",
          Get_Gender_Text(HoV_RACE_gender_id),
          Get_HoV_RACE_Text(HoV_RACE_gender_id),
          Get_HoV_CLASS_Text(HoV_CLASS_id),
        ];
      }

      return name;
    } catch (ex) {
      return "";
    }
  };

  const Get_HoV_CLASS_Text = (ptype) => {
    if (ptype == HoV_CLASS_WARRIOR) return "Warrior";
    else if (ptype == HoV_CLASS_RANGER) return "Ranger";
    else if (ptype == HoV_CLASS_MAGE) return "Mage";
    else if (ptype == HoV_CLASS_ASSASSIN) return "Assassin";
    else if (ptype == HoV_CLASS_TANK) return "Tank";
    else if (ptype == HoV_CLASS_CLERIC) return "Cleric";

    return "";
  };

  const Get_Gender_Text = (ptype) => {
    if (
      ptype == HoV_RACE_GENDER_DWARF_MALE ||
      ptype == HoV_RACE_GENDER_ELF_MALE ||
      ptype == HoV_RACE_GENDER_HUMAN_MALE ||
      ptype == HoV_RACE_GENDER_ORC_MALE
    )
      return "Male";
    else if (
      ptype == HoV_RACE_GENDER_DWARF_FEMALE ||
      ptype == HoV_RACE_GENDER_ELF_FEMALE ||
      ptype == HoV_RACE_GENDER_HUMAN_FEMALE ||
      ptype == HoV_RACE_GENDER_ORC_FEMALE
    )
      return "Female";

    return "";
  };

  const Get_HoV_RACE_Text = (ptype) => {
    if (
      ptype == HoV_RACE_GENDER_DWARF_MALE ||
      ptype == HoV_RACE_GENDER_DWARF_FEMALE
    )
      return "Dwarf";
    else if (
      ptype == HoV_RACE_GENDER_ELF_MALE ||
      ptype == HoV_RACE_GENDER_ELF_FEMALE
    )
      return "Elf";
    else if (
      ptype == HoV_RACE_GENDER_HUMAN_MALE ||
      ptype == HoV_RACE_GENDER_HUMAN_FEMALE
    )
      return "Human";
    else if (
      ptype == HoV_RACE_GENDER_ORC_MALE ||
      ptype == HoV_RACE_GENDER_ORC_FEMALE
    )
      return "Orc";

    return "";
  };

  const setAllClasses = (item) => {
    alert(item);
  };

  const sortltoh = () => {
    const sorted = [...sortedAuctions].sort((a, b) => {
      return a.directBuy - b.directBuy;
    });
    setSortedAuctions(sorted);
  };

  const sorthtol = () => {
    const sorted = [...sortedAuctions].sort((a, b) => {
      return b.directBuy - a.directBuy;
    });
    setSortedAuctions(sorted);
  };

  const getAllAuctions = async () => {
    let allnftscurrent = [];
    let sortedArray = [];
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        console.log(this.responseText);
        allnftscurrent = JSON.parse(this.responseText);
        setAllMarketNft(allnftscurrent);
        setPleaseWait(false);
      }
      
    });
    xhr.open("GET", "https://marketplaceapi.heroeschained.com/getnftiteminfo");
    xhr.send();

    const connector = new WalletConnect({
      bridge: "https://bridge.walletconnect.org", // Required
      qrcodeModal: QRCodeModal,
    });

    const web3Instance = new Web3("https://api.avax.network/ext/bc/C/rpc");
    const abiInterface = new web3Instance.eth.Contract(abi, contractAdress);
    let allAuctionsList = await abiInterface.methods
      .getAuctionInfo(1050)
      .call();
    for (let i = 0; i < allAuctionsList.auctionIds.length; i++) {
      sortedArray.push({
        auctionId: allAuctionsList.auctionIds[i],
        directBuy: allAuctionsList.directBuy[i],
        owner: allAuctionsList.owner[i],
        startPrice: allAuctionsList.startPrice[i],
        highestBid: allAuctionsList.highestBid[i],
        auctionStates: allAuctionsList.auctionStates[i],
        auctionNFTAddress: allAuctionsList.auctionNFTAddress[i],
        tokenId: allAuctionsList.tokenIds[i],
      });
    }
    setSortedAuctions(sortedArray);
    console.log("testtt: " + sortedAuctions);

    if (walletType == "metamask" || walletType == "") {
      await ethereum.enable();
      const provider = await detectEthereumProvider();
      const web3Instance = new Web3(provider);
      const abiInterface = new web3Instance.eth.Contract(abi, contractAdress);
      //let allAuctionsList = await abiInterface.methods.getAuctionInfo(500).call({from: publicKey});
      let sortedArray = [];
      let gameSortedArray = [];
      // for (let i = 0; i < allAuctionsList.auctionIds.length; i++) {
      //   sortedArray.push({
      //     auctionId: allAuctionsList.auctionIds[i],
      //     directBuy: allAuctionsList.directBuy[i],
      //     owner: allAuctionsList.owner[i],
      //     startPrice: allAuctionsList.startPrice[i],
      //     highestBid: allAuctionsList.highestBid[i],
      //     auctionStates: allAuctionsList.auctionStates[i],
      //     auctionNFTAddress: allAuctionsList.auctionNFTAddress[i],
      //     tokenId:allAuctionsList.tokenIds[i]
      //   })
      // }

      // setTimeout(function() {
      //   setSortedAuctions(sortedArray);
      //   console.log("testtt: "+ sortedAuctions);
      //   setPleaseWait(false);
      // }, 5000);
    } else if (walletType == "walletconnect") {
      await ethereum.enable();
      if (!connector.connected) {
        // create new session
        connector.createSession();
      }
      const provider = new WalletConnectProvider({
        rpc: {
          43114: "https://api.avax.network/ext/bc/C/rpc",
        },
        chainId: 43114,
        bridge: "https://bridge.walletconnect.org",
        qrcodeModal: QRCodeModal,
      });

      await provider.enable();

      let web3Instance = new Web3(provider);
      const abiInterface = new web3Instance.eth.Contract(abi, contractAdress);
      //let allAuctionsList = await abiInterface.methods.getAuctionInfo(500).call({from: publicKey});
      // let sortedArray =[];
      // for (let i = 0; i < allAuctionsList.auctionIds.length; i++) {
      //   sortedArray.push({
      //     auctionId: allAuctionsList.auctionIds[i],
      //     directBuy: allAuctionsList.directBuy[i],
      //     owner: allAuctionsList.owner[i],
      //     highestBid: allAuctionsList.highestBid[i],
      //     auctionStates: allAuctionsList.auctionStates[i],
      //     auctionNFTAddress: allAuctionsList.auctionNFTAddress[i],
      //     tokenId:allAuctionsList.tokenIds[i]
      //   })
      // }

      // setTimeout(function() {
      //   setSortedAuctions(sortedArray);
      //   console.log("testtt: "+ sortedAuctions);
      //   setPleaseWait(false);
      // }, 5000);
    }
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
    console.log(newChecked);
  };

  const handleTextInputChange = (event) => {
    setTextInput(event.target.value);
  };

  const gotoAssets = (path, data) => {
    navigate(`/shop/${path}`, data);
  };

  const showLevels = async (tokenid) => {
    const web3Instance = new Web3("https://api.avax.network/ext/bc/C/rpc");
    const detailInterface = new web3Instance.eth.Contract(
      detailAbi,
      detailContract
    );

    /* old Blockchain fetch
     let nftGameDetail = await detailInterface.methods
      .VIEW_Get_Hero_Levels(
        "0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB",
        tokenid
    )
    .call();*/
    var ap = 10;
    var dp = 10;
    var el = 1;
    const response = await fetch("http://fov2.heroeschained.com/HCFOVApi/api/HeroDatas/getherobasestats?mHId="+tokenid);
    if(response.ok){
      var j = await response.json();
      ap = j.data.ap;
      dp = j.data.dp;
      el = j.data.el;
    }
    setAplevelval(ap);//(nftGameDetail[1]);
    setDplevelval(dp);//(nftGameDetail[2]);
    setEllevelval(el);//(nftGameDetail[3]);
  };

  useEffect(() => {
    getAllAuctions();
  }, [walletType]);

  return (
    <MarketplaceWrapper>
      <div className="sidebar-container">
        <div
          className="for-sale"
          style={{
            width: "calc(100% - 20px)",
            height: "70px",
            marginLeft: "10px",
            textAlign: "center",
          }}
        >
          <TextField
            sx={{
              ".MuiInputLabel-root": { color: "white" },
              ".MuiButtonBase-root": { color: "white" },
              ".MuiSvgIcon-root": { color: "white" },
              ".MuiChip-deleteIcon": { color: "white !important" },
              ".MuiOutlinedInput-notchedOutline": { borderColor: "white" },
              ".MuiOutlinedInput-input": { color: "white !important" },
            }}
            className="mobileinputsearch firstmobilesearch"
            style={{
              color: "white",
              float: "left",
              width: "440px",
              marginTop: "10px",
            }}
            label="Search"
            placeholder="Search..."
            value={textInput}
            onChange={handleTextInputChange}
          />
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            className="mobileinputsearch"
            options={["All", "MayinHara", "Fortunes of Ventuna", "Weapon","Heroes of Ventuna"]}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            onChange={(event, newValue) => {
              if (newValue.includes("All") || newValue.length == 0) {
                setSelectedCollections([
                  "MayinHara",
                  "Fortunes of Ventuna",
                  "Weapon",
                  "Heroes of Ventuna"
                ]);
              } else {
                setSelectedCollections(newValue);
              }
            }}
            sx={{
              ".MuiInputLabel-root": { color: "white" },
              ".MuiButtonBase-root": { color: "white" },
              ".MuiSvgIcon-root": { color: "white" },
              ".MuiChip-deleteIcon": { color: "white !important" },
              ".MuiOutlinedInput-notchedOutline": { borderColor: "white" },
              ".MuiOutlinedInput-input": { color: "white !important" },
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            style={{
              width: 410,
              marginTop: "10px",
              float: "left",
              marginLeft: "10px",
            }}
            renderInput={(params) => (
              <TextField
                style={{ color: "white" }}
                {...params}
                label="NFT Collection"
                placeholder="NFT Collection"
              />
            )}
          />

          <FormControl
            style={{
              color: "white",
              width: "250px",
              marginTop: "10px",
              float: "left",
              marginLeft: "10px",
            }}
            className="mobileinputsearch"
            sx={{
              ".MuiOutlinedInput-notchedOutline": { borderColor: "white" },
              ".MuiSvgIcon-root": { color: "white !important" },
            }}
          >
            <InputLabel
              id="demo-simple-select-label"
              style={{ color: "white" }}
            >
              Sorting
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={age}
              label="Sorting"
              onChange={handleChange}
              style={{ color: "white" }}
            >
              <MenuItem onClick={sortltoh} value={10}>
                Price: Lowest to Highest
              </MenuItem>
              <MenuItem onClick={sorthtol} value={20}>
                Price: Highest to Lowest
              </MenuItem>
            </Select>
          </FormControl>
          <div style={{ marginLeft: "10px", float: "left", width: "200px" }}>
            <FormControlLabel
              value={forsale}
              onChange={() => setForsale(!forsale)}
              control={<Switch color="primary" defaultChecked />}
              label="FOR SALE"
              labelPlacement="start"
            />
            <FormControlLabel
              value={isFilter}
              onChange={() => setIsFilter(!isFilter)}
              control={<Switch color="primary" defaultChecked />}
              label={
                <span>
                  <FilterListIcon />
                  FILTER
                </span>
              }
              labelPlacement="start"
            />
          </div>
        </div>

        {!(
          selectedCollections.includes("Fortunes of Ventuna") &&
          selectedCollections.includes("MayinHara") &&
          selectedCollections.includes("Weapon") &&
          selectedCollections.includes("Heroes of Ventuna")
        ) &&
          selectedCollections.includes("MayinHara") &&
          isFilter && (
            <div className="filters-container" style={{ marginLeft: "auto" }}>
              <div className="dropdown-filter">
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={[
                    "All",
                    "The Beacons of Light",
                    "The Bringers of Day",
                    "The First Hope",
                    "The Judgement Bearers",
                    "The Last Guard",
                  ]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedGenerations([
                        "The Beacons of Light",
                        "The Bringers of Day",
                        "The First Hope",
                        "The Judgement Bearers",
                        "The Last Guard",
                      ]);
                    } else {
                      setSelectedGenerations(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Generation"
                      placeholder="Generation"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={[
                    "All",
                    "Archer",
                    "Cleric",
                    "Mage",
                    "Tank",
                    "Warrior",
                  ]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedClasses([
                        "Archer",
                        "Cleric",
                        "Mage",
                        "Tank",
                        "Warrior",
                      ]);
                    } else {
                      setSelectedClasses(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Class"
                      placeholder="Class"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={[
                    "All",
                    "Ithara",
                    "Jeela",
                    "Nilchee",
                    "Talam",
                    "Tamburian",
                  ]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedArmourMaterials([
                        "Ithara",
                        "Jeela",
                        "Nilchee",
                        "Talam",
                        "Tamburian",
                      ]);
                    } else {
                      setSelectedArmourMaterials(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Armour Material"
                      placeholder="Armour Material"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "Galleer I", "Galleer II", "Galleer III"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedHeads([
                        "Galleer I",
                        "Galleer II",
                        "Galleer III",
                      ]);
                    } else {
                      setSelectedHeads(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Head"
                      placeholder="Head"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "Thrax I", "Thrax II", "Thrax III"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedTorsos(["Thrax I", "Thrax II", "Thrax III"]);
                    } else {
                      setSelectedTorsos(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Torso"
                      placeholder="Torso"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "Kastus I", "Kastus II", "Kastus III"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedArms(["Kastus I", "Kastus II", "Kastus III"]);
                    } else {
                      setSelectedArms(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Arm"
                      placeholder="Arm"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "Skappa I", "Skappa II", "Skappa III"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedShoulders([
                        "Skappa I",
                        "Skappa II",
                        "Skappa III",
                      ]);
                    } else {
                      setSelectedShoulders(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Shoulder"
                      placeholder="Shoulder"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "Lakka I", "Lakka II"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedSkirts(["Lakka I", "Lakka II"]);
                    } else {
                      setSelectedSkirts(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Skirt"
                      placeholder="Skirt"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={[
                    "All",
                    "Hallis I",
                    "Hallis II",
                    "Hallis III",
                    "Hallis IV",
                  ]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedWings([
                        "Hallis I",
                        "Hallis II",
                        "Hallis III",
                        "Hallis IV",
                      ]);
                    } else {
                      setSelectedWings(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Wing"
                      placeholder="Wing"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "0", "0.5", "0.75", "1", "1.25", "1.5"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedAPs(["0", "0.5", "0.75", "1", "1.25", "1.5"]);
                    } else {
                      setSelectedAPs(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Attack Power Boost %"
                      placeholder="Attack Power Boost %"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "0", "0.5", "0.75", "1", "1.25", "1.5"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedDPs(["0", "0.5", "0.75", "1", "1.25", "1.5"]);
                    } else {
                      setSelectedDPs(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Defence Power Boost %"
                      placeholder="Defence Power Boost %"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "0", "0.5", "0.75", "1", "1.25", "1.5"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedSCs(["0", "0.5", "0.75", "1", "1.25", "1.5"]);
                    } else {
                      setSelectedSCs(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Spell Card Boost %"
                      placeholder="Spell Card Boost %"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "0", "0.5", "0.75", "1", "1.25", "1.5"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedUSs(["0", "0.5", "0.75", "1", "1.25", "1.5"]);
                    } else {
                      setSelectedUSs(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Ultimate Skill Boost %"
                      placeholder="Ultimate Skill Boost %"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "0", "0.5", "0.75", "1", "1.25", "1.5"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedHBs(["0", "0.5", "0.75", "1", "1.25", "1.5"]);
                    } else {
                      setSelectedHBs(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Health Boost %"
                      placeholder="Health Boost %"
                    />
                  )}
                />
              </div>
            </div>
          )}

        {!(
          selectedCollections.includes("Fortunes of Ventuna") &&
          selectedCollections.includes("MayinHara") &&
          selectedCollections.includes("Weapon") &&
          selectedCollections.includes("Heroes of Ventuna")
        ) &&
          selectedCollections.includes("Fortunes of Ventuna") &&
          isFilter && (
            <div className="filters-container" style={{ marginLeft: "auto" }}>
              <div className="dropdown-filter">
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "Gemstone", "Training Ticket"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedTypes(["Gemstone", "Training Ticket"]);
                    } else {
                      setSelectedTypes(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Type"
                      placeholder="Type"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "Attacking", "Defending"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedTrainingTypes(["Attacking", "Defending"]);
                    } else {
                      setSelectedTrainingTypes(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Training Type"
                      placeholder="Training Type"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={[
                    "All",
                    "Attacking",
                    "Defending",
                    "Explorer Level",
                    "MEGA",
                  ]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedGemstoneType([
                        "Attacking",
                        "Defending",
                        "Explorer Level",
                        "MEGA",
                      ]);
                    } else {
                      setSelectedGemstoneType(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Gemstone Type"
                      placeholder="Gemstone Type"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "1", "2", "3"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedBoostAmount(["1", "2", "3"]);
                    } else {
                      setSelectedBoostAmount(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Boost Amount"
                      placeholder="Boost Amount"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "1", "2", "3"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedUpgradeAmount(["1", "2", "3"]);
                    } else {
                      setSelectedUpgradeAmount(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Upgrade Amount"
                      placeholder="Upgrade Amount"
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  className="mobileinputsearch"
                  options={["All", "72", "120", "168"]}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  onChange={(event, newValue) => {
                    if (newValue.includes("All") || newValue.length == 0) {
                      setSelectedTrainingHours(["0", "72", "120", "168"]);
                    } else {
                      setSelectedTrainingHours(newValue);
                    }
                  }}
                  sx={{
                    ".MuiInputLabel-root": { color: "white" },
                    ".MuiButtonBase-root": { color: "white" },
                    ".MuiSvgIcon-root": { color: "white" },
                    ".MuiChip-deleteIcon": { color: "white !important" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    ".MuiOutlinedInput-input": { color: "white !important" },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  style={{
                    width: 220,
                    marginTop: "10px",
                    float: "left",
                    marginLeft: "10px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      style={{ color: "white" }}
                      {...params}
                      label="Training Hours"
                      placeholder="Training Hours"
                    />
                  )}
                />
              </div>
            </div>
          )}

{!(
    selectedCollections.includes("Fortunes of Ventuna") &&
    selectedCollections.includes("MayinHara") &&
    selectedCollections.includes("Weapon") &&
    selectedCollections.includes("Heroes of Ventuna")
  ) &&
    selectedCollections.includes("Heroes of Ventuna") &&
    isFilter && (
      <div className="filters-container" style={{ marginLeft: "auto" }}>
        <div className="dropdown-filter">
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            className="mobileinputsearch"
            options={["All", "Male", "Female"]}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            onChange={(event, newValue) => {
              if (newValue.includes("All") || newValue.length == 0) {
                setSelectedGenderTypes(["Male", "Female"]);
              } else {
                setSelectedGenderTypes(newValue);
              }
            }}
            sx={{
              ".MuiInputLabel-root": { color: "white" },
              ".MuiButtonBase-root": { color: "white" },
              ".MuiSvgIcon-root": { color: "white" },
              ".MuiChip-deleteIcon": { color: "white !important" },
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              ".MuiOutlinedInput-input": { color: "white !important" },
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            style={{
              width: 220,
              marginTop: "10px",
              float: "left",
              marginLeft: "10px",
            }}
            renderInput={(params) => (
              <TextField
                style={{ color: "white" }}
                {...params}
                label="Gender"
                placeholder="Gender"
              />
            )}
          />

          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            className="mobileinputsearch"
            options={["All", "Human", "Orc","Elf","Dwarf"]}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            onChange={(event, newValue) => {
              if (newValue.includes("All") || newValue.length == 0) {
                setSelectedRaceypes(["Human", "Orc","Elf","Dwarf"]);
              } else {
                setSelectedRaceypes(newValue);
              }
            }}
            sx={{
              ".MuiInputLabel-root": { color: "white" },
              ".MuiButtonBase-root": { color: "white" },
              ".MuiSvgIcon-root": { color: "white" },
              ".MuiChip-deleteIcon": { color: "white !important" },
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              ".MuiOutlinedInput-input": { color: "white !important" },
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            style={{
              width: 220,
              marginTop: "10px",
              float: "left",
              marginLeft: "10px",
            }}
            renderInput={(params) => (
              <TextField
                style={{ color: "white" }}
                {...params}
                label="Race"
                placeholder="Race"
              />
            )}
          />

          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            className="mobileinputsearch"
            options={[
              "All",
              "Warrior",
              "Ranger",
              "Mage",
              "Assassin",
              "Tank",
              "Cleric"
            ]}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            onChange={(event, newValue) => {
              if (newValue.includes("All") || newValue.length == 0) {
                setSelectedClassHovType([
                  "Warrior",
                  "Ranger",
                  "Mage",
                  "Assassin",
                  "Tank",
                  "Cleric"
                ]);
              } else {
                setSelectedClassHovType(newValue);
              }
            }}
            sx={{
              ".MuiInputLabel-root": { color: "white" },
              ".MuiButtonBase-root": { color: "white" },
              ".MuiSvgIcon-root": { color: "white" },
              ".MuiChip-deleteIcon": { color: "white !important" },
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
              ".MuiOutlinedInput-input": { color: "white !important" },
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            style={{
              width: 220,
              marginTop: "10px",
              float: "left",
              marginLeft: "10px",
            }}
            renderInput={(params) => (
              <TextField
                style={{ color: "white" }}
                {...params}
                label="Class"
                placeholder="Class"
              />
            )}
          />

          
        </div>
      </div>
    )}
      </div>
      <div className="nft-container">
        <div className="banner">
          {/* <h1>Welcome to the NFT Marketplace</h1>
          <h3>Here you can search and buy MayinHara NFTs</h3> */}
        </div>
        {!pleaseWait && (
          <div className="nft-items">
            {sortedAuctions.map((item, value) =>
              item.auctionNFTAddress ==
              "0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? (
                !forsale ? (
                  selectedClasses.includes(
                    allMarketNft[item.tokenId - 1].attributes[0].value
                  ) &&
                  selectedArmourMaterials.includes(
                    allMarketNft[item.tokenId - 1].attributes[2].value
                  ) &&
                  selectedHeads.includes(
                    allMarketNft[item.tokenId - 1].attributes[3].value
                  ) &&
                  selectedTorsos.includes(
                    allMarketNft[item.tokenId - 1].attributes[4].value
                  ) &&
                  selectedArms.includes(
                    allMarketNft[item.tokenId - 1].attributes[5].value
                  ) &&
                  selectedShoulders.includes(
                    allMarketNft[item.tokenId - 1].attributes[6].value
                  ) &&
                  selectedSkirts.includes(
                    allMarketNft[item.tokenId - 1].attributes[7].value
                  ) &&
                  selectedWings.includes(
                    allMarketNft[item.tokenId - 1].attributes[8].value
                  ) &&
                  selectedAPs.includes(
                    allMarketNft[item.tokenId - 1].attributes[9].value
                  ) &&
                  selectedDPs.includes(
                    allMarketNft[item.tokenId - 1].attributes[10].value
                  ) &&
                  selectedSCs.includes(
                    allMarketNft[item.tokenId - 1].attributes[11].value
                  ) &&
                  selectedUSs.includes(
                    allMarketNft[item.tokenId - 1].attributes[12].value
                  ) &&
                  selectedHBs.includes(
                    allMarketNft[item.tokenId - 1].attributes[13].value
                  ) &&
                  selectedGenerations.includes(
                    allMarketNft[item.tokenId - 1].attributes[1].value
                  ) &&
                  selectedCollections.includes("MayinHara") &&
                  item.tokenId.includes(textInput) && (
                    <div
                      className="nft-card tooltip2"
                      onMouseEnter={() => showLevels(item.tokenId)}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        gotoAssets(`asset-${item.auctionId}`, {
                          data: item.tokenId,
                        })
                      }
                    >
                      <span class="tooltiptext">
                        AP: {aplevelval} <br />
                        DP: {dplevelval}
                        <br />
                        EL: {ellevelval}
                      </span>
                      <div
                        className="nft-options"
                        style={{ marginBottom: "5px" }}
                      >
                        <span
                          style={{
                            padding: "0 5px",
                            background: "orange",
                            borderRadius: "10px",
                          }}
                        >
                          #{item.tokenId}
                        </span>
                      </div>
                      <div className="nft-options">
                        <img
                          title={
                            allMarketNft[item.tokenId - 1].attributes[0].value
                          }
                          alt={
                            allMarketNft[item.tokenId - 1].attributes[0].value
                          }
                          style={{ width: "30px", height: "auto" }}
                          src={
                            allMarketNft[item.tokenId - 1].attributes[0].value +
                            ".png"
                          }
                        />{" "}
                        {allMarketNft[item.tokenId - 1].attributes[0].value}
                      </div>
                      <div className="img-container">
                        <img
                          src={
                            "https://mayinhara.s3.eu-central-1.amazonaws.com/thumbnails/" +
                            item.tokenId +
                            "_thumb.png"
                          }
                          alt="MayinHara"
                        />
                      </div>
                      <div className="nft-info">
                        <h6 style={{ textAlign: "center" }}>
                          {allMarketNft[item.tokenId - 1].attributes[1].value}
                        </h6>
                        {/* <h3>MayinHara #{item.tokenId}</h3> */}
                        <div style={{ display: "grid", gap: ".5rem" }}>
                          <div
                            className="nft-count"
                            style={{ textAlign: "center" }}
                          >
                            <span>
                              {item.auctionStates == "0" ? "OPEN" : "ENDED"}
                            </span>{" "}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[9]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost9.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[9]
                                  .value
                              }
                            </span>
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[10]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost10.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[10]
                                  .value
                              }
                            </span>
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[11]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost11.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[11]
                                  .value
                              }
                            </span>
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[12]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost12.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[12]
                                  .value
                              }
                            </span>
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[13]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost13.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[13]
                                  .value
                              }
                            </span>
                          </div>
                          <div className="nft-sales">
                            <div className="nft-price">
                              <div>
                                <span>
                                  Highest:{" "}
                                  {(
                                    parseInt(item.highestBid) /
                                    10 ** 18
                                  ).toLocaleString("en-US")}{" "}
                                  <img
                                    src="logos/heroeslogo.svg"
                                    style={{ width: "20px" }}
                                    alt="test-y"
                                  />
                                </span>
                                <span style={{ marginTop: "5px" }}>
                                  Start:{" "}
                                  {(
                                    parseInt(item.startPrice) /
                                    10 ** 18
                                  ).toLocaleString("en-US")}{" "}
                                  <img
                                    src="logos/heroeslogo.svg"
                                    style={{ width: "20px" }}
                                    alt="test-y"
                                  />
                                </span>
                                <span style={{ marginTop: "5px" }}>
                                  Price:{" "}
                                  {(
                                    parseInt(item.directBuy) /
                                    10 ** 18
                                  ).toLocaleString("en-US")}{" "}
                                  <img
                                    src="logos/heroeslogo.svg"
                                    style={{ width: "20px" }}
                                    alt="test-y"
                                  />
                                </span>
                              </div>
                            </div>
                            <ShoppingCartIcon />
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  item.auctionStates == "0" &&
                  selectedClasses.includes(
                    allMarketNft[item.tokenId - 1].attributes[0].value
                  ) &&
                  selectedGenerations.includes(
                    allMarketNft[item.tokenId - 1].attributes[1].value
                  ) &&
                  selectedArmourMaterials.includes(
                    allMarketNft[item.tokenId - 1].attributes[2].value
                  ) &&
                  selectedHeads.includes(
                    allMarketNft[item.tokenId - 1].attributes[3].value
                  ) &&
                  selectedTorsos.includes(
                    allMarketNft[item.tokenId - 1].attributes[4].value
                  ) &&
                  selectedArms.includes(
                    allMarketNft[item.tokenId - 1].attributes[5].value
                  ) &&
                  selectedShoulders.includes(
                    allMarketNft[item.tokenId - 1].attributes[6].value
                  ) &&
                  selectedSkirts.includes(
                    allMarketNft[item.tokenId - 1].attributes[7].value
                  ) &&
                  selectedWings.includes(
                    allMarketNft[item.tokenId - 1].attributes[8].value
                  ) &&
                  selectedAPs.includes(
                    allMarketNft[item.tokenId - 1].attributes[9].value
                  ) &&
                  selectedDPs.includes(
                    allMarketNft[item.tokenId - 1].attributes[10].value
                  ) &&
                  selectedSCs.includes(
                    allMarketNft[item.tokenId - 1].attributes[11].value
                  ) &&
                  selectedUSs.includes(
                    allMarketNft[item.tokenId - 1].attributes[12].value
                  ) &&
                  selectedHBs.includes(
                    allMarketNft[item.tokenId - 1].attributes[13].value
                  ) &&
                  selectedCollections.includes("MayinHara") &&
                  item.tokenId.includes(textInput) && (
                    <div
                      className="nft-card tooltip2"
                      onMouseEnter={() => showLevels(item.tokenId)}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        gotoAssets(`asset-${item.auctionId}`, {
                          data: item.tokenId,
                        })
                      }
                    >
                      <span class="tooltiptext">
                        <div style={{ marginTop: "5px" }}>
                          <span style={{ color: "#ffbf36" }}>AP: </span>
                          {aplevelval}
                        </div>{" "}
                        <div style={{ marginTop: "5px" }}>
                          <span style={{ color: "#ffbf36" }}>DP: </span>
                          {dplevelval}
                        </div>{" "}
                        <div style={{ marginTop: "5px" }}>
                          <span style={{ color: "#ffbf36" }}>EL: </span>
                          {ellevelval}
                        </div>
                      </span>
                      <div
                        className="nft-options"
                        style={{ marginBottom: "5px" }}
                      >
                        <span
                          style={{
                            padding: "0 5px",
                            background: "orange",
                            borderRadius: "10px",
                          }}
                        >
                          #{item.tokenId}
                        </span>
                      </div>
                      <div className="nft-options">
                        <img
                          title={
                            allMarketNft[item.tokenId - 1].attributes[0].value
                          }
                          alt={
                            allMarketNft[item.tokenId - 1].attributes[0].value
                          }
                          style={{ width: "30px", height: "auto" }}
                          src={
                            allMarketNft[item.tokenId - 1].attributes[0].value +
                            ".png"
                          }
                        />{" "}
                        {allMarketNft[item.tokenId - 1].attributes[0].value}
                      </div>
                      <div className="img-container">
                        <img
                          src={
                            "https://mayinhara.s3.eu-central-1.amazonaws.com/thumbnails/" +
                            item.tokenId +
                            "_thumb.png"
                          }
                          alt="MayinHara"
                        />
                      </div>
                      <div className="nft-info">
                        <h6 style={{ textAlign: "center" }}>
                          {allMarketNft[item.tokenId - 1].attributes[1].value}
                        </h6>
                        {/* <h3>MayinHara #{item.tokenId}</h3> */}
                        <div style={{ display: "grid", gap: ".5rem" }}>
                          <div
                            className="nft-count"
                            style={{ textAlign: "center" }}
                          >
                            <span>
                              {item.auctionStates == "0" ? "OPEN" : "ENDED"}
                            </span>{" "}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[9]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost9.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[9]
                                  .value
                              }
                            </span>
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[10]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost10.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[10]
                                  .value
                              }
                            </span>
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[11]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost11.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[11]
                                  .value
                              }
                            </span>
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[12]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost12.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[12]
                                  .value
                              }
                            </span>
                            <span
                              style={{
                                display:
                                  allMarketNft[item.tokenId - 1].attributes[13]
                                    .value == 0
                                    ? "none"
                                    : "unset",
                              }}
                            >
                              <img
                                style={{ width: "20px", height: "auto" }}
                                src="boost13.png"
                              />{" "}
                              {
                                allMarketNft[item.tokenId - 1].attributes[13]
                                  .value
                              }
                            </span>
                          </div>
                          <div className="nft-sales">
                            <div className="nft-price">
                              <div>
                                <span>
                                  Highest:{" "}
                                  {(
                                    parseInt(item.highestBid) /
                                    10 ** 18
                                  ).toLocaleString("en-US")}{" "}
                                  <img
                                    src="logos/heroeslogo.svg"
                                    style={{ width: "20px" }}
                                    alt="test-y"
                                  />
                                </span>
                                <span style={{ marginTop: "5px" }}>
                                  Start:{" "}
                                  {(
                                    parseInt(item.startPrice) /
                                    10 ** 18
                                  ).toLocaleString("en-US")}{" "}
                                  <img
                                    src="logos/heroeslogo.svg"
                                    style={{ width: "20px" }}
                                    alt="test-y"
                                  />
                                </span>
                                <span style={{ marginTop: "5px" }}>
                                  Price:{" "}
                                  {(
                                    parseInt(item.directBuy) /
                                    10 ** 18
                                  ).toLocaleString("en-US")}{" "}
                                  <img
                                    src="logos/heroeslogo.svg"
                                    style={{ width: "20px" }}
                                    alt="test-y"
                                  />
                                </span>
                              </div>
                            </div>
                            <ShoppingCartIcon />
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )
              ) : selectedCollections.includes("Weapon") &&
                item.auctionStates == "0" &&
                item.auctionNFTAddress ==
                  "0x9c9F19434D2f0154b3dc04913c9e02A0dD969E52" &&
                forsale ? (
                <div
                  className="nft-card"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    gotoAssets(`asset-${item.auctionId}`, {
                      data: item.tokenId,
                    })
                  }
                >
                  <div className="nft-options" style={{ marginBottom: "5px" }}>
                    <span
                      style={{
                        padding: "0 5px",
                        background: "orange",
                        borderRadius: "10px",
                      }}
                    >
                      Weapon #{item.tokenId}
                    </span>
                  </div>
                  <div className="img-container">
                    <img
                      style={{ height: "200px" }}
                      src={
                        "https://hcbw.s3.eu-central-1.amazonaws.com/the_skullscreamer2.png"
                      }
                      alt="Ticket"
                    />
                  </div>
                  <div className="nft-info">
                    <h6 style={{ textAlign: "center" }}>
                      The Skullscreamer #{item.tokenId}
                    </h6>
                    {/* <h3>MayinHara #{item.tokenId}</h3> */}
                    <div style={{ display: "grid", gap: ".5rem" }}>
                      <div className="nft-sales">
                        <div className="nft-price">
                          <div>
                            <span>
                              Highest:{" "}
                              {(
                                parseInt(item.highestBid) /
                                10 ** 18
                              ).toLocaleString("en-US")}{" "}
                              <img
                                src="logos/heroeslogo.svg"
                                style={{ width: "20px" }}
                                alt="test-y"
                              />
                            </span>
                            <span style={{ marginTop: "5px" }}>
                              Start:{" "}
                              {(
                                parseInt(item.startPrice) /
                                10 ** 18
                              ).toLocaleString("en-US")}{" "}
                              <img
                                src="logos/heroeslogo.svg"
                                style={{ width: "20px" }}
                                alt="test-y"
                              />
                            </span>
                            <span style={{ marginTop: "5px" }}>
                              Price:{" "}
                              {(
                                parseInt(item.directBuy) /
                                10 ** 18
                              ).toLocaleString("en-US")}{" "}
                              <img
                                src="logos/heroeslogo.svg"
                                style={{ width: "20px" }}
                                alt="test-y"
                              />
                            </span>
                          </div>
                        </div>
                        <ShoppingCartIcon />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                selectedCollections.includes("Fortunes of Ventuna") ?
                (!forsale
                  ? ((selectedTypes.includes("Gemstone") &&
                      selectedTypes.includes(
                        getFovAttributes(item.tokenId)[0]
                      ) &&
                      selectedGemstoneType.includes(
                        getFovAttributes(item.tokenId)[1]
                      ) &&
                      selectedBoostAmount.includes(
                        getFovAttributes(item.tokenId)[2].toString()
                      )) ||
                      (selectedTypes.includes("Training Ticket") &&
                        selectedTypes.includes(
                          getFovAttributes(item.tokenId)[0]
                        ) &&
                        selectedTrainingTypes.includes(
                          getFovAttributes(item.tokenId)[1]
                        ) &&
                        selectedUpgradeAmount.includes(
                          getFovAttributes(item.tokenId)[2].toString()
                        ) &&
                        selectedTrainingHours.includes(
                          getFovAttributes(item.tokenId)[3].toString()
                        ))) &&
                    item.tokenId.includes(textInput) && (
                      <div
                        className="nft-card"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          gotoAssets(`asset-${item.auctionId}`, {
                            data: item.tokenId,
                          })
                        }
                      >
                        <div
                          className="nft-options"
                          style={{ marginBottom: "5px" }}
                        >
                          <span
                            style={{
                              padding: "0 5px",
                              background: "orange",
                              borderRadius: "10px",
                            }}
                          >
                            #{item.tokenId}
                          </span>
                        </div>
                        <div className="img-container">
                          <img
                            src={
                              "https://fov.heroeschained.com/api/NFT/FOVImage/" +
                              item.tokenId
                            }
                            alt="MayinHara"
                          />
                        </div>
                        <div className="nft-info">
                          <h6 style={{ textAlign: "center" }}>
                            {parseFoVTokenID(item.tokenId.toString())}
                          </h6>
                          {/* <h3>MayinHara #{item.tokenId}</h3> */}
                          <div style={{ display: "grid", gap: ".5rem" }}>
                            <div className="nft-sales">
                              <div className="nft-price">
                                <div>
                                  <span>
                                    Highest:{" "}
                                    {(
                                      parseInt(item.highestBid) /
                                      10 ** 18
                                    ).toLocaleString("en-US")}{" "}
                                    <img
                                      src="logos/heroeslogo.svg"
                                      style={{ width: "20px" }}
                                      alt="test-y"
                                    />
                                  </span>
                                  <span style={{ marginTop: "5px" }}>
                                    Start:{" "}
                                    {(
                                      parseInt(item.startPrice) /
                                      10 ** 18
                                    ).toLocaleString("en-US")}{" "}
                                    <img
                                      src="logos/heroeslogo.svg"
                                      style={{ width: "20px" }}
                                      alt="test-y"
                                    />
                                  </span>
                                  <span style={{ marginTop: "5px" }}>
                                    Price:{" "}
                                    {(
                                      parseInt(item.directBuy) /
                                      10 ** 18
                                    ).toLocaleString("en-US")}{" "}
                                    <img
                                      src="logos/heroeslogo.svg"
                                      style={{ width: "20px" }}
                                      alt="test-y"
                                    />
                                  </span>
                                </div>
                              </div>
                              <ShoppingCartIcon />
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  : item.auctionStates == "0" &&
                    ((selectedTypes.includes("Gemstone") &&
                      selectedTypes.includes(
                        getFovAttributes(item.tokenId)[0]
                      ) &&
                      selectedGemstoneType.includes(
                        getFovAttributes(item.tokenId)[1]
                      ) &&
                      selectedBoostAmount.includes(
                        getFovAttributes(item.tokenId)[2].toString()
                      )) ||
                      (selectedTypes.includes("Training Ticket") &&
                        selectedTypes.includes(
                          getFovAttributes(item.tokenId)[0]
                        ) &&
                        selectedTrainingTypes.includes(
                          getFovAttributes(item.tokenId)[1]
                        ) &&
                        selectedUpgradeAmount.includes(
                          getFovAttributes(item.tokenId)[2].toString()
                        ) &&
                        selectedTrainingHours.includes(
                          getFovAttributes(item.tokenId)[3].toString()
                        ))) &&
                    item.tokenId.includes(textInput) && (
                      <div
                        className="nft-card"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          gotoAssets(`asset-${item.auctionId}`, {
                            data: item.tokenId,
                          })
                        }
                      >
                        <div
                          className="nft-options"
                          style={{ marginBottom: "5px" }}
                        >
                          <span
                            style={{
                              padding: "0 5px",
                              background: "orange",
                              borderRadius: "10px",
                            }}
                          >
                            #{item.tokenId}
                          </span>
                        </div>
                        <div className="img-container">
                          <img
                            src={
                              "https://fov.heroeschained.com/api/NFT/FOVImage/" +
                              item.tokenId
                            }
                            alt="MayinHara"
                          />
                        </div>
                        <div className="nft-info">
                          <h6 style={{ textAlign: "center" }}>
                            {parseFoVTokenID(item.tokenId.toString())}
                          </h6>
                          {/* <h3>MayinHara #{item.tokenId}</h3> */}
                          <div style={{ display: "grid", gap: ".5rem" }}>
                            <div className="nft-sales">
                              <div className="nft-price">
                                <div>
                                  <span>
                                    Highest:{" "}
                                    {(
                                      parseInt(item.highestBid) /
                                      10 ** 18
                                    ).toLocaleString("en-US")}{" "}
                                    <img
                                      src="logos/heroeslogo.svg"
                                      style={{ width: "20px" }}
                                      alt="test-y"
                                    />
                                  </span>
                                  <span style={{ marginTop: "5px" }}>
                                    Start:{" "}
                                    {(
                                      parseInt(item.startPrice) /
                                      10 ** 18
                                    ).toLocaleString("en-US")}{" "}
                                    <img
                                      src="logos/heroeslogo.svg"
                                      style={{ width: "20px" }}
                                      alt="test-y"
                                    />
                                  </span>
                                  <span style={{ marginTop: "5px" }}>
                                    Price:{" "}
                                    {(
                                      parseInt(item.directBuy) /
                                      10 ** 18
                                    ).toLocaleString("en-US")}{" "}
                                    <img
                                      src="logos/heroeslogo.svg"
                                      style={{ width: "20px" }}
                                      alt="test-y"
                                    />
                                  </span>
                                </div>
                              </div>
                              <ShoppingCartIcon />
                            </div>
                          </div>
                        </div>
                      </div>
                    )) : (
                      selectedCollections.includes("Heroes of Ventuna") &&
                      (!forsale
                        ? (   selectedGenderTypes.includes(
                                getFovAttributes(item.tokenId)[1]
                              ) &&
                              selectedRaceypes.includes(
                                getFovAttributes(item.tokenId)[2]
                              ) &&
                              selectedClassHovType.includes(
                                getFovAttributes(item.tokenId)[3]
                              ) &&
                               item.tokenId.includes(textInput) && (
                            <div
                              className="nft-card"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                gotoAssets(`asset-${item.auctionId}`, {
                                  data: item.tokenId,
                                })
                              }
                            >
                              <div
                                className="nft-options"
                                style={{ marginBottom: "5px" }}
                              >
                                <span
                                  style={{
                                    padding: "0 5px",
                                    background: "orange",
                                    borderRadius: "10px",
                                  }}
                                >
                                  #{item.tokenId}
                                </span>
                              </div>
                              <div className="img-container">
                                <img
                                  src={
                                    "https://fov.heroeschained.com/api/NFT/FOVImage/" +
                                    item.tokenId
                                  }
                                  alt="MayinHara"
                                />
                              </div>
                              <div className="nft-info">
                                <h6 style={{ textAlign: "center" }}>
                                  {parseFoVTokenID(item.tokenId.toString())}
                                </h6>
                                {/* <h3>MayinHara #{item.tokenId}</h3> */}
                                <div style={{ display: "grid", gap: ".5rem" }}>
                                  <div className="nft-sales">
                                    <div className="nft-price">
                                      <div>
                                        <span>
                                          Highest:{" "}
                                          {(
                                            parseInt(item.highestBid) /
                                            10 ** 18
                                          ).toLocaleString("en-US")}{" "}
                                          <img
                                            src="logos/heroeslogo.svg"
                                            style={{ width: "20px" }}
                                            alt="test-y"
                                          />
                                        </span>
                                        <span style={{ marginTop: "5px" }}>
                                          Start:{" "}
                                          {(
                                            parseInt(item.startPrice) /
                                            10 ** 18
                                          ).toLocaleString("en-US")}{" "}
                                          <img
                                            src="logos/heroeslogo.svg"
                                            style={{ width: "20px" }}
                                            alt="test-y"
                                          />
                                        </span>
                                        <span style={{ marginTop: "5px" }}>
                                          Price:{" "}
                                          {(
                                            parseInt(item.directBuy) /
                                            10 ** 18
                                          ).toLocaleString("en-US")}{" "}
                                          <img
                                            src="logos/heroeslogo.svg"
                                            style={{ width: "20px" }}
                                            alt="test-y"
                                          />
                                        </span>
                                      </div>
                                    </div>
                                    <ShoppingCartIcon />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        : item.auctionStates == "0" &&
                          (selectedGenderTypes.includes(
                              getFovAttributes(item.tokenId)[1]
                            ) &&
                            selectedRaceypes.includes(
                              getFovAttributes(item.tokenId)[2]
                            ) &&
                            selectedClassHovType.includes(
                              getFovAttributes(item.tokenId)[3]
                            ) &&
                             item.tokenId.includes(textInput)) && 
                          item.tokenId.includes(textInput) && (
                            <div
                              className="nft-card"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                gotoAssets(`asset-${item.auctionId}`, {
                                  data: item.tokenId,
                                })
                              }
                            >
                              <div
                                className="nft-options"
                                style={{ marginBottom: "5px" }}
                              >
                                <span
                                  style={{
                                    padding: "0 5px",
                                    background: "orange",
                                    borderRadius: "10px",
                                  }}
                                >
                                  #{item.tokenId}
                                </span>
                              </div>
                              <div className="img-container">
                                <img
                                  src={
                                    "https://fov.heroeschained.com/api/NFT/FOVImage/" +
                                    item.tokenId
                                  }
                                  alt="MayinHara"
                                />
                              </div>
                              <div className="nft-info">
                                <h6 style={{ textAlign: "center" }}>
                                  {parseFoVTokenID(item.tokenId.toString())}
                                </h6>
                                {/* <h3>MayinHara #{item.tokenId}</h3> */}
                                <div style={{ display: "grid", gap: ".5rem" }}>
                                  <div className="nft-sales">
                                    <div className="nft-price">
                                      <div>
                                        <span>
                                          Highest:{" "}
                                          {(
                                            parseInt(item.highestBid) /
                                            10 ** 18
                                          ).toLocaleString("en-US")}{" "}
                                          <img
                                            src="logos/heroeslogo.svg"
                                            style={{ width: "20px" }}
                                            alt="test-y"
                                          />
                                        </span>
                                        <span style={{ marginTop: "5px" }}>
                                          Start:{" "}
                                          {(
                                            parseInt(item.startPrice) /
                                            10 ** 18
                                          ).toLocaleString("en-US")}{" "}
                                          <img
                                            src="logos/heroeslogo.svg"
                                            style={{ width: "20px" }}
                                            alt="test-y"
                                          />
                                        </span>
                                        <span style={{ marginTop: "5px" }}>
                                          Price:{" "}
                                          {(
                                            parseInt(item.directBuy) /
                                            10 ** 18
                                          ).toLocaleString("en-US")}{" "}
                                          <img
                                            src="logos/heroeslogo.svg"
                                            style={{ width: "20px" }}
                                            alt="test-y"
                                          />
                                        </span>
                                      </div>
                                    </div>
                                    <ShoppingCartIcon />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                    )
              )
            )}
          </div>
        )}
      </div>
    </MarketplaceWrapper>
  );
};

export default Marketplace;
